import React from 'react';

function Current(props) {
  return (
    <div>
      <h3>TLC Cleaning is now booking jobs for early October if you're interested in having your house detailed! Message me for a consultation!</h3>
      <h3>Cleaning a house is more than vacuuming and dusting.  It's making your showers and tubs look new, your stove top and oven gleaming; your sinks look new, washing your walls, grime from corners you never look at!  It's a masterpiece, a work of art.  "Cleaning is Caring" ❤️</h3>
  </div>
  );
}

export default Current;
